import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import ProductPageSectionProps from '../../../domains/ProductPageSectionProps'

import Product from '@src/quince-site-common/src/domains/Product'

import { ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'

import BundlePageSectionProps from '@src/quince-site-pdp/src/domains/BundlePageSectionProps'

import ProductComparisonBrand from '@src/quince-site-common/src/domains/ProductComparisonBrand'
import BrandComparisonBundle from './BrandComparisonBundle'
import BrandComparisonProduct from './BrandComparisonProduct'

const NO_OF_BRANDS_DESKTOP = 3
const NO_OF_BRANDS_MOBILE = 2

const BrandComparison = (props: BundlePageSectionProps | ProductPageSectionProps) => {
  return 'bundle' in props ? <BrandComparisonBundle {...props} /> : <BrandComparisonProduct {...props} />
}

export const getBrandComparisonsForDevice = (comparisonBrands: ProductComparisonBrand[], isMobile: boolean) => {
  return comparisonBrands.slice(0, isMobile ? NO_OF_BRANDS_MOBILE : NO_OF_BRANDS_DESKTOP)
}

export const getProductComparisionBrands = (
  product: Product,
  selectedOptions: ProductVariantOption[],
  isMobile: boolean,
  getAllBrands = false,
) => {
  const comparisionBrands = productHelper
    .getBrandComparison(product, selectedOptions || [])
    .filter(pcb => pcb.showOnSite)
  return getAllBrands ? comparisionBrands : getBrandComparisonsForDevice(comparisionBrands, isMobile)
}

export default BrandComparison
